import {
    SET_BLOB_LINK,
    SET_CATALOG_LIST,
    SET_CITIES_LIST, SET_COMPANY_FIND_BY_INN,
    SET_CONTRACTS_DETAIL,
    SET_CONTRACTS_FIELDS_ITEM,
    UPDATE_BLOCKED_STATUS
} from "./constans";


let initialState = {};

const contractsDetailReducers = (state = initialState, action) => {

    switch (action.type) {
        case SET_CONTRACTS_DETAIL :
            return {...state, ...action.payload}
        case SET_CONTRACTS_FIELDS_ITEM :
            return {...state, ...action.payload}
        case SET_BLOB_LINK:
            return {...state, blobLink: action.payload}
        case UPDATE_BLOCKED_STATUS:
            return {...state, blocked: action.newStatus}
        case SET_CITIES_LIST:
            return {...state, citiesList: action.payload}
        case SET_CATALOG_LIST:
            return {...state, catalogList: action.payload}
        case SET_COMPANY_FIND_BY_INN:
            return {...state, companyFindByINN: action.payload}

        default:
            return state;
    }
};


export default contractsDetailReducers;